// @flow
import React from "react";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import {
  FINANCE_CHECK_IHK_TALK,
  FINANCE_CHECK_IHK,
  FINANCE_CHECK_IHK_CONSULTANT,
  FINANCE_CHECK_INFORMATION_SHEET
} from "./formFields";

import { type InvestmentSectionProps } from "../../types/details";
import * as mappers from "../../utils/mappers";

const InvestmentFinancingCheck = ({ initialValues, handleSubmit }: InvestmentSectionProps) => (
  <EditableForm initialValues={initialValues} onSubmit={handleSubmit} isLocked>
    <FormRow separator>
      <EditableField
        fieldControlProps={{
          name: FINANCE_CHECK_IHK_TALK,
          caption: () => "IHK-Gespräch geführt?"
        }}
        displayValue={mappers.yesNoMapper}
      />
      <EditableField
        fieldControlProps={{
          name: FINANCE_CHECK_IHK,
          caption: () => "IHK"
        }}
      />
      <EditableField
        fieldControlProps={{
          name: FINANCE_CHECK_IHK_CONSULTANT,
          caption: () => "IHK-Berater"
        }}
      />
    </FormRow>
    <FormRow>
      <EditableField
        fieldControlProps={{
          name: FINANCE_CHECK_INFORMATION_SHEET,
          caption: () => "Informationsformular vorhanden?"
        }}
        displayValue={mappers.yesNoMapper}
      />
    </FormRow>
  </EditableForm>
);

export default InvestmentFinancingCheck;
